import React from 'react';
import type { GetServerSidePropsContext } from 'next';
import dynamic from 'next/dynamic';

import { getSnowdonJwt } from '~/domains/auth/utils';
import { campaginDateRange } from '~/domains/campaign/helper';
import MarketBottomSheet from '~/domains/mmp/MarketBottomSheet';
import { prefetchReactQueryData } from '~/libs/reactQuery';
import type { NextPageWithLayout } from '~/types';

import { HomeLayout } from './components/HomeLayout';
import HomeMainContents from './components/HomeMainContents';
import { HomeTracker } from './components/HomeTracker';
import MarketHomeEvent from './components/MarketHomeEvent';

const MarketHomeFloatingWrapper = dynamic(
  () => import('./components/MarketHomeFloatingWrapper'),
  {
    ssr: false,
  },
);

const AppHome: NextPageWithLayout = () => {
  return (
    <>
      <HomeTracker />
      <HomeMainContents />
      <MarketHomeFloatingWrapper />
      <MarketBottomSheet />
      <MarketHomeEvent />
    </>
  );
};

AppHome.Layout = HomeLayout;
export default AppHome;

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const { req } = context;
  const { businessId } = req.cookies;

  const token = getSnowdonJwt(context) || null;

  if (!token || !businessId) {
    return {
      props: {},
    };
  }

  const { dehydratedState } = await prefetchReactQueryData({
    queries: [
      [
        '/api/market-place/v1/placements/home-top-showcases',
        {
          businessId: Number(businessId),
        },
      ],
      [
        '/api/market-place/v1/placements/banners',
        {
          businessId: Number(businessId),
          placement: 'market_card_banner_with_floating',
        },
      ],
      [
        '/api/market-place/v1/placements/navigation-bars-new',
        {
          businessId: Number(businessId),
        },
      ],
      [
        '/api/market-place/v1/placements/popups',
        {
          businessId: Number(businessId),
          placement: '마켓 홈 바텀시트',
        },
      ],

      '/api/market-place/v1/buyer',
      [
        '/api/market-place/v1/campaigns/home',
        {
          date: campaginDateRange.TODAY,
        },
      ],
      '/api/market-place/v1/shopping-cart-items/count',
      '/api/market-place/v1/buyer-coupon/count',
      '/api/market-place/v1/frequently-order/products',
    ],

    fetchOptions: {
      headers: {
        'X-Client-Auth-Token': token,
      },
    },
  });

  return {
    props: {
      dehydratedState,
    },
  };
}
